import WaterfallChartIcon from '@mui/icons-material/WaterfallChart';
import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { MouseEvent, useCallback } from 'react';
import {
  selectedFundStateFP,
  waterfallConfigDisplayState,
  WaterfallConfigTogglesValue,
} from '../state/FPState';
import { highlightedCellsAtom, selectedCellKeyAtom } from './WaterfallFormulasConfig';

export function WaterfallConfigToggles() {
  const [value, setValue] = useAtom(waterfallConfigDisplayState);
  const fund = useAtomValue(selectedFundStateFP);
  const setHighlightedCells = useSetAtom(highlightedCellsAtom);
  const setSelectedCellKey = useSetAtom(selectedCellKeyAtom);

  const onChange = useCallback(
    (event: MouseEvent, newValue: WaterfallConfigTogglesValue) => {
      setValue(newValue);
      if (!newValue || newValue !== 'calcs') {
        setHighlightedCells(null);
        setSelectedCellKey(null);
      }
    },
    [setValue, setHighlightedCells, setSelectedCellKey]
  );

  if (!fund) {
    return null;
  }

  return (
    <ToggleButtonGroup
      color='secondary'
      value={value}
      onChange={onChange}
      exclusive
      aria-label='show/hide waterfall config'
      sx={{ '.MuiToggleButton-root': { width: '2.25rem' } }}
    >
      <ToggleButton value='tiers' title='show/hide tier configuration'>
        <WaterfallChartIcon fontSize='small' />
      </ToggleButton>
      <ToggleButton value='calcs' title='show/hide calculations'>
        <Typography variant='body2'>
          𝑓<sub>x</sub>
        </Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
